import React from 'react';
import { ButtonsRow, CleanFilter, ModalContent, SaveButton, StyledModal, FormGroupWrapper } from './styled';
import { MultiSelectDropdown, FilterOption } from 'newComponents/Form/Multiselect';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';

interface PlanosModalProps {
  title: string;
  setClose: (open: boolean) => void;
  maintenanceUnitsOptions: FilterOption[];
  planosOptions: FilterOption[];
  maintenanceUnitsValues: string[];
  planosValues: string[];
  onMaintenanceUnitsChange: (values: unknown) => void;
  onPlanosChange: (values: unknown) => void;
  onFilter: () => void;
  onClearFilters: () => void;
}

export const PlanosModal: React.FC<PlanosModalProps> = ({
  title,
  setClose,
  maintenanceUnitsOptions,
  planosOptions,
  maintenanceUnitsValues,
  planosValues,
  onMaintenanceUnitsChange,
  onPlanosChange,
  onFilter,
  onClearFilters,
}) => {
  return (
    <StyledModal title={title} setClose={setClose}>
      <ModalContent>
        <FormGroupWrapper>
          <FormGroup label="Unidades de manutenção">
            <MultiSelectDropdown
              options={maintenanceUnitsOptions}
              value={maintenanceUnitsValues}
              onChange={onMaintenanceUnitsChange}
              size="md"
              width="416px"
              placeholder="Selecione"
              clearable={true}
              top="27px"
            />
          </FormGroup>
        </FormGroupWrapper>

        <FormGroupWrapper>
          <FormGroup label="Planos">
            <MultiSelectDropdown
              options={planosOptions}
              value={planosValues}
              onChange={onPlanosChange}
              size="md"
              width="416px"
              placeholder="Selecione"
              clearable={true}
              top="27px"
              searchable={true}
              temSelecionarTodos={true}
              showScrollbar={true}
            />
          </FormGroup>
        </FormGroupWrapper>

        <ButtonsRow>
          <SaveButton onClick={onFilter}>Filtrar</SaveButton>
          <CleanFilter onClick={onClearFilters} title="Limpar filtros de Planos">
            <XIcon />
            Limpar filtros
          </CleanFilter>
        </ButtonsRow>
      </ModalContent>
    </StyledModal>
  );
};
